import { AppCoreEnums } from 'src/core/shared/enums';
import { IDynamicFilterItem } from 'src/stores/core/models';
import useContainerDynamicFiltersStore from './use-container-dynamic-filters-store';

export default () => {
  const { resetContainerDynamicFilters, addContainerDynamicFilter } = useContainerDynamicFiltersStore();

  const updateStoreWithInitialDynamicFilters = (
    initialDynamicFilters: IDynamicFilterItem[] | undefined,
    containerType: AppCoreEnums.ContainerType
  ) => {
    resetContainerDynamicFilters(containerType);
    initialDynamicFilters?.forEach((x) => addContainerDynamicFilter(containerType, x));
  };

  return {
    updateStoreWithInitialDynamicFilters,
  };
};
